export default __webpack_public_path__ + "static/media/640_dummy2016-cafe01-mobile-de.0e2f213e.png";